import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export class Slider {
  constructor()
  {
    new Swiper('.testimonial-swiper', {
      spaceBetween: 50,
      loop: true,
      centeredSlides: true,
      speed: 450,
      breakpoints: {
        559: {
          spaceBetween: 100,
        },
      },
      modules: [Autoplay, Pagination, Navigation],
      autoplay: {
        delay: 15000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}




// WEBPACK FOOTER //
// ./js/util/slider.js